export const MRP_SHEET_API = "/api/mrp_sheet";
/** MRP-only filter storage — do not share Styles/Fabric `styles_table_filter_obj`. */
export const mrpSheetFilterValStr = "mrp_sheet_table_filter_obj";
/** Legacy key used before MRP got its own storage; read once for migration. */
export const mrpSheetFilterValStrLegacy = "styles_table_filter_obj";

export const mrpSheetExportOptions = [
	{
		key: "STANDARD",
		name: "Standard",
		apiUrl: `${MRP_SHEET_API}/download_styles`,
		fileName: "mrp_sheet_styles",
		usePythonApi: false,
	},
	{
		key: "GINESYS_FORMAT",
		name: "Ginesys Format",
		apiUrl: "/api/download_styles_ginesys_format",
		fileName: "mrp_styles_ginesys_format",
		usePythonApi: true,
	},
	{
		key: "FULL_DUMP",
		name: "Full Dump",
		apiUrl: "/api/download_styles_dump",
		fileName: "mrp_all_styles_dump",
		usePythonApi: true,
	},
];
